// extracted by mini-css-extract-plugin
export default {"img":"src-components-ImgixPicture-ImgixPicture__img"};